/**
 * Wrapper button for the design library button to pass our router specific link
 */

import { Link } from 'react-router-dom';

import ButtonProps from 'tailwind/components/Button/Button.types';
import { default as DesignLibraryButton } from 'tailwind/components/Button/Button';

const Button = ({ href, ...rest }: Omit<ButtonProps, 'linkComponent' | 'linkProps'>) => (
  <DesignLibraryButton {...rest} href={href} linkComponent={Link} linkProps={{ to: href }} />
);

export default Button;
